import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=7b122a04&scoped=true&"
import script from "./Template.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Template.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Template.vue?vue&type=style&index=0&id=7b122a04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b122a04",
  null
  
)

export default component.exports